import {
  Elements,
  PaymentElement,
  useElements,
  useStripe
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Button, Col, Row, useStateIn } from 'straightline-ui';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function PaymentMethodForm({
  clientSecret,
  onSuccess,
  onCancel,
  onError
}) {
  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: {
          theme: 'stripe'
        }
      }}
    >
      <PaymentMethodSetupInnerForm
        clientSecret={clientSecret}
        onSuccess={onSuccess}
        onCancel={onCancel}
        onError={onError}
      />
    </Elements>
  );
}

const PaymentMethodSetupInnerForm = ({
  clientSecret,
  onSuccess,
  onCancel,
  onError
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const {
    state: { isSubmitting },
    assignState
  } = useStateIn({
    isSubmitting: false
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements || isSubmitting) {
      return;
    }

    assignState({ isSubmitting: true });

    try {
      const { error: submitError } = await elements.submit();

      if (submitError) {
        throw submitError;
      }

      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/settings/billing`
        },
        redirect: 'if_required'
      });

      if (error) {
        throw error;
      }

      onSuccess(setupIntent);
    } catch (error) {
      onError(error);
    } finally {
      assignState({ isSubmitting: false });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      <Row className="mt-4">
        <Col>
          <Button
            type="button"
            color="secondary"
            block
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
        </Col>
        <Col>
          <Button
            type="submit"
            color="primary"
            block
            disabled={!stripe || isSubmitting}
            loading={isSubmitting}
          >
            Save Payment Method
          </Button>
        </Col>
      </Row>
    </form>
  );
};
